import { Injectable } from '@angular/core';
import {CrudService} from '../crud.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NewsService extends CrudService{

  constructor(
      httpClient: HttpClient
  ) {
      super(httpClient, 'announces');
  }
}
